import React from "react";

import EntityPage from "~/pages/Editor/EditorCatalogEducationalPrograms/EntityPage";
import { GroupsManagement } from "~/pages/Editor/EditorCatalogEducationalPrograms/EditorGroups/GroupsManagement";
import { useGetGroupsData } from "~/pages/Editor/EditorCatalogEducationalPrograms/hooks";
import { getCurriculumColumns } from "~/pages/Editor/EditorCatalogEducationalPrograms/model/tableAdapter";
import { groupsTableHeader } from "~/pages/Editor/EditorCatalogEducationalPrograms/options";

const EditorGroups = () => (
  <EntityPage
    titleKey="cep.groups"
    createPermission="employeeAccounting.curriculum.group.create"
    updatePermission="employeeAccounting.curriculum.group.update"
    tableHeader={groupsTableHeader}
    getColumns={getCurriculumColumns("cep.groups_table")}
    useData={useGetGroupsData}
    Management={GroupsManagement}
    formId="GroupForm"
    editTitleKey="cep.edit_group"
    addTitleKey="cep.add_group"
  />
);

export default EditorGroups;
